import { useApi } from "../../api/client";
import { commitsList } from "../../api/contracts/commits";
import { Skeleton } from "../../skeleton";
import { CommitList } from "../commit-list";
import { PeekDialogSection } from "../peek-dialog";

interface TaskCommitsSectionProps {
  taskId: number;
}

/**
 * Task-peek body extension. Fetches commits linked to this task and renders
 * them in a CommitList under the peek's house section heading. Owns its own
 * `PeekDialogSection` (rather than being wrapped by the caller) so a task with
 * no linked commits renders NOTHING — a bare "Commits" heading over emptiness
 * is worse than the absence.
 */
export function TaskCommitsSection({ taskId }: TaskCommitsSectionProps) {
  // A task's linked commits are few; the first page (route default 50) is the
  // whole set in practice, so this reads the envelope without a pager.
  const { data, isLoading } = useApi(commitsList, { query: { task_id: taskId } });

  if (isLoading) {
    return (
      <PeekDialogSection title="Commits">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </PeekDialogSection>
    );
  }

  const commits = data?.rows ?? [];
  if (commits.length === 0) return null;

  return (
    <PeekDialogSection title="Commits" count={data?.total ?? commits.length}>
      <CommitList commits={commits} />
    </PeekDialogSection>
  );
}
